<template>
  <v-layout align-start>
    <v-flex>
      <v-toolbar flat color="white">
        <v-toolbar-title>Notas de Crédito</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-text-field
          v-if="verNuevo == 0"
          class="text-xs-center"
          v-model="search"
          append-icon="search"
          label="Búsqueda"
          single-line
          hide-details
        ></v-text-field>
        <v-flex  v-if="verNuevo == 0" xs3 sm3 md3>
          <v-select
            v-model="tipocomprobante2"
             :items="comprobantes2"
            label="Tipo Nota Credito"
            autocomplete="on"
            v-on:change="listar"
          >
          </v-select>
        </v-flex>
        <v-btn
          v-if="verNuevo == 0"
          @click="listar()"
          color="primary"
          dark
          class="mb-2"
          >Buscar</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          v-if="verNuevo == 0"
          @click="mostrarNuevo"
          color="primary"
          dark
          class="mb-2"
          >Nuevo</v-btn
        >
        <v-dialog
          v-model="verArticulos"
          max-width="1000px"
          transition="dialog-bottom-transition"
        >
          <v-card>
            <v-card-title>
              <span class="headline">Seleccione una factura</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12 md12 lg12 xl12>
                    <v-text-field
                      append-icon="search"
                      class="text-xs-center"
                      v-model="texto"
                      label="Ingrese el número del factura a buscar"
                      @keyup="listarArticulo()"
                    >
                    </v-text-field>
                    <template>
                      <v-data-table
  :headers="cabeceraFacturas"
  :items="articulos"
  class="elevation-1"
>
  <template slot="items" slot-scope="props">
    <tr  @click="agregarDetalle(props.item)">
      <!-- Icono de añadir -->
      <td class="justify-center layout px-0">
        <v-icon small class="mr-2">add</v-icon>
      </td>
      <!-- Información de la factura -->
      <td>{{ props.item.codigoFactura }}</td>
      <td>{{ props.item.cliente }}</td>
      <td>{{ props.item.tipo_comprobante }}</td>
      <td>{{ props.item.sucursal }}</td>
      <td>{{ props.item.usuario }}</td>
      <td>{{ props.item.fecha_hora | moment("DD/MM/YYYY") }} | {{ props.item.fecha_hora | moment("LT") }}</td>
      <td>{{ formatCurrency(props.item.total) }}</td>
    </tr>
  </template>
  <template slot="no-data">
    <h3>No hay artículos para mostrar.</h3>
  </template>
</v-data-table>

                    </template>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="ocultarArticulos()" color="blue darken" flat>
                Cancelar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="adModal" max-width="290">
          <v-card>
            <v-card-title class="headline" v-if="adAccion == 1"
              >¿Activar Item?</v-card-title
            >
            <v-card-title class="headline" v-if="adAccion == 2"
              >¿Anular Nota Credito?</v-card-title
            >
            <v-card-text>
              Estás a punto de
              <span v-if="adAccion == 1">Activar </span>
              <span v-if="adAccion == 2">Anular </span>
              el ítem {{ adNombre }}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="green darken-1"
                flat="flat"
                @click="activarDesactivarCerrar"
              >
                Cancelar
              </v-btn>
              <v-btn
                v-if="adAccion == 1"
                color="orange darken-4"
                flat="flat"
                @click="activar"
              >
                Activar
              </v-btn>
              <v-btn
                v-if="adAccion == 2"
                color="orange darken-4"
                flat="flat"
                @click="desactivar"
              >
                Anular
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="comprobanteModal" max-width="500px">
  <v-card>
    <v-card-text>
      <v-btn @click="imprimir()">
        <v-icon>print</v-icon>
      </v-btn>
      <!-- <v-btn @click="crearPDF()">
        <v-icon>description</v-icon>
      </v-btn> -->

      <!-- Vista previa (ticket-preview) -->
      <div v-if="isPreview" id="ticket-preview" class="ticket-preview">
        <!-- <div id="logo">
        <img id="imagen" src="@/assets/variedades-aby-logo.jpg" alt="Variedades Aby" style="max-width: 150px; height: auto;" />
  </div> -->

        <div class="detalles">
          <h5>No. Nota de Crédito: {{ noNotaCredito }}</h5>
          <h5>No. Factura: {{ num_factura + ' - ' + tipo_comprobante }}</h5>
          <h5>Fecha: {{ fecha_hora | moment("DD/MM/YYYY") }} | {{ fecha_hora | moment("LT") }}</h5>
        </div>
        <br>
        <hr />
        <div class="cliente">
          <h5>Tipo de Nota de Crédito: {{ tipoNC }}</h5>
        </div>
        <br>
        <hr />

        <div class="cliente">
          <h5>Cliente: {{ cliente }}</h5>
        </div>

        <hr />

        <table  v-if="detalles.length > 0" class="factura-tabla">
          <thead>
            <tr>
              <th>Cantidad</th>
              <th>Producto</th>
              <th>Precio</th>
              <th>Descuento</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="det in detalles" :key="det.iddetalle_venta">
              <td>{{ det.cantidad }}</td>
              <td>{{ det.articulo }}</td>
              <td>{{ formatCurrency(det.precio)}}</td>
              <td>{{ formatCurrency(det.descuento) }}</td>
              <td>{{ formatCurrency((det.cantidad * det.precio - det.descuento)) }}</td>
            </tr>
          </tbody>
        </table>

        <hr />

        <div class="totales">
          <div v-if="parseFloat(descuentoNC) > 0">SUBTOTAL: {{ formatCurrency(subtotalNC)}}</div>
          <div v-if="parseFloat(descuentoNC) > 0">DESCUENTO: {{  formatCurrency(descuentoNC) }}</div>
          <div>
             TOTAL: {{  formatCurrency(totalNC) }}
          </div>
          <p  v-if="observaciones !=''" style="font-weight: bold; font-size: 15px; text-align: center;">
              *** OBSERVACIONES ***  
        </p>
        <p  v-if="observaciones !=''" style="font-weight: unset; font-size: 12px; text-align: center;">
          - {{ observaciones }} 
        </p>

        </div>
      </div>

      <!-- Contenido a imprimir (ticket) -->
      <div v-if="!isPreview" id="ticket">
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/materialize/1.0.0-beta/css/materialize.min.css" media="print" />
        <div id="logo">
          <img style="text-align: center; margin-top: 0px; margin-bottom: 0px;" id="imagen" src="@/assets/logo-print2.jpg" alt="Aby" />
        </div>

        <div>
          <!-- <h5 style="font-weight: bold; font-size: 25px">NO. {{ num_factura }}</h5>
          <h5 style="font-weight: bold; font-size: 25px">FACTURA: {{ tipo_comprobante }}</h5>
          <h5 style="font-weight: bold; font-size: 25px">FECHA: {{ fecha_hora | moment("DD/MM/YYYY") }} | {{ fecha_hora | moment("LT") }}</h5> -->

          <h5 style="font-weight: bold; font-size: 25px">No. Nota de Crédito: {{ noNotaCredito }}</h5>
          <h5 style="font-weight: bold; font-size: 25px">No. Factura: {{ num_factura + ' - ' + tipo_comprobante }}</h5>
          <h5 style="font-weight: bold; font-size: 25px">Fecha: {{ fecha_hora | moment("DD/MM/YYYY") }} | {{ fecha_hora | moment("LT") }}</h5>
        </div>

        <br />
        <div class="flow-text">
          <h5 style="font-weight: bold; font-size: 20px">Tipo de Nota de Crédito: {{ tipoNC }}</h5>
        </div>
        <hr>
        <div>
          <div class="flow-text">
            <h5 style="font-weight: bold; font-size: 20px">Cliente: {{ cliente }}</h5>            
          </div>
        </div>

        <hr>

        <table>
  <!-- Encabezados de la tabla (solo aparecen en la primera página) -->
  <tr   v-if="detalles.length > 0">
    <th>Cantidad</th>
    <th>Producto</th>
    <th>Precio</th>
    <!-- <th>Descuento</th> -->
    <th>Total</th>
  </tr>

  <!-- Cuerpo de la tabla -->
  <tbody   v-if="detalles.length > 0">
    <tr v-for="det in detalles" :key="det.iddetalle_venta">
      <td>{{ det.cantidad }}</td>
      <td>{{ det.articulo }}</td>
      <td>{{ formatCurrency(det.precio) }}</td>
      <!-- <td>{{ det.descuento }}</td> -->
      <td>{{ formatCurrency((det.cantidad * det.precio)) }}</td>
    </tr>
  </tbody>

  <!-- Pie de la tabla que solo debe aparecer al final de la última página -->
  <tfoot>
    <tr  v-if="parseFloat(descuentoNC) > 0">
      <td colspan="2"></td>
      <td>Subtotal:</td>
      <td>{{ formatCurrency(subtotalNC) }}</td>
    </tr>
    <tr  v-if="parseFloat(descuentoNC) > 0">
      <td colspan="2"></td>
      <td>Descuento:</td>
      <td>{{ formatCurrency(descuentoNC) }}</td>
    </tr>
    <tr>
      <td colspan="2"></td>
      <td>Total:</td>
      <td>{{ formatCurrency(totalNC) }}</td>
    </tr>
  </tfoot>
</table>
<br />
<p  v-if="observaciones !=''" style="font-weight: bold; font-size: 25px; text-align: center;">
              *** OBSERVACIONES ***  
        </p>
        <p   v-if="observaciones !=''" style="font-weight: unset; font-size: 20px; text-align: center;">
          - {{ observaciones }} 
        </p>
        <br />
        <strong style="font-weight: bold; font-size: 20px">Atendido por: {{ vendedor }}</strong><br /><br />
       
      </div>

      <v-btn @click="ocultarComprobante" color="blue darken-1" flat>Cancelar</v-btn>
    </v-card-text>
  </v-card>
</v-dialog>

    

      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="ventas"
        :search="search"
        :custom-sort="customSort"
        class="elevation-1"
        v-if="verNuevo == 0"
      >
        <template slot="items" slot-scope="props">
          <td class="justify-center layout px-0">
            <!-- <v-icon small class="mr-2" @click="verDetalles(props.item)">
              tab
            </v-icon> -->
            <v-icon small class="mr-2" @click="mostrarComprobante(props.item)">
              print
            </v-icon>
            <template v-if="props.item.estado!= 'Anulado' ">
              <v-icon small @click="activarDesactivarMostrar(2, props.item)">
                block
              </v-icon>
            </template>
          </td>

          <td>{{ props.item.codigoNC }}</td>
          <td>{{ props.item.tipoNc }}</td>
          <td>{{ props.item.cliente }}</td>
          <td>{{ props.item.fechaCreacion | moment("DD/MM/YYYY") }}</td>
          <td>
            <div class="text-center">
              <span v-if="props.item.estado == 'Aplicada'">
                <v-chip class="ma-2" color="cyan" label text-color="white">
                  <v-icon left> check_circle </v-icon>
                  {{ props.item.estado }}
                </v-chip>
              </span>
              <span v-if="props.item.estado == 'Anulado'">
                <v-chip class="ma-2" color="red accent-4" label text-color="white">
                  <v-icon left> highlight_off </v-icon>
                  {{ props.item.estado }}
                </v-chip>
              </span>
            </div>
          </td>

          <td>{{ formatCurrency(props.item.totalNC) }}</td>
          <td>{{ props.item.codigoFactura }}</td>
          <td>{{ props.item.sucursal }}</td>
          <td>{{ props.item.usuario }}</td>
          <td>{{ props.item.tipo_comprobante }}</td>
           
        </template>
        <template slot="no-data">
          <v-btn color="primary" @click="listar">Resetear</v-btn>
        </template>
      </v-data-table>
      <v-container grid-list-sm class="pa-4 white" v-if="verNuevo">
        <v-layout row wrap>
          <v-flex xs12 sm5 md5 lg5 xl5>
            <v-select
              v-model="tipocomprobante"
               @change="validarNC($event)"
              :items="comprobantes"
              label="Tipo de Nota de Crédito"
            >
            </v-select>
          </v-flex>
          <v-spacer></v-spacer>     
          <v-spacer></v-spacer>
          <v-flex xs12 sm6 md6 lg6 xl6>
            <v-select
              v-model="customer"
              @change="limpiarData()"
              :items="clientes"
              label="Clientes"
              autocomplete="on"
            >
            </v-select>
          </v-flex>
          <v-flex v-if="aplicarDescuento" xs12 sm4 md4 lg4 xl4>
            <v-text-field
  :value="descuento.toLocaleString('en-US')"
  label="Valor de descuento"
  prefix="C$"
  outlined
  @input="descuento = Number($event.replace(/,/g, ''))"
/>

</v-flex>

      

          <v-flex xs12 sm2 md2 lg2 xl2>
  <v-btn @click="mostrarArticulos()" small dark color="teal" class="d-flex align-center">
    <v-icon dark>list</v-icon>
    <span class="ml-2">Buscar facturas</span> <!-- Agrega el texto aquí -->
  </v-btn>
</v-flex>
<v-flex xs12 sm2 md2 lg2 xl2>
</v-flex>
<v-flex xs12 sm6 md6 lg6 xl6>
            <!-- Mostrar solo si tiene valor -->
            <div v-if="codigoFactura">
              <strong>{{ codigoFactura }}</strong>
            </div>            
            
            <div v-if="tipoFactura">
              <strong>{{ tipoFactura }}</strong>
            </div>
            <div v-if="sucursalFactura">
            <strong>  {{ sucursalFactura }}</strong>
            <div v-if="totalFactura">
               <strong>Total Factura: {{ formatCurrency(totalFactura) }}</strong>
            </div>
            </div>
</v-flex>
          <v-flex xs12 sm2 md2 lg2 xl2 v-if="errorArticulo">
            <div class="red--text" v-text="errorArticulo"></div>
          </v-flex>
          <v-flex xs12 sm12 md12 lg12 xl12>
  <v-data-table
    :headers="cabeceraDetalles"
    :items="detalles"
    hide-actions
    class="elevation-1"
  >
    <template slot="items" slot-scope="props">
      <td style="text-align: center; vertical-align: middle;">
        <v-checkbox
          v-model="props.item.selected"
          dense
          hide-details
            @change="toggleSelection(props.item)"
        ></v-checkbox>
      </td>

      <td>{{ props.item.articulo }}</td>
      <td>
        <v-text-field
          type="number"
          v-model="props.item.cantidad"
          disabled="disabled"
          @keydown.up.prevent="handleKeyDown"
          @keydown.down.prevent="handleKeyDown"
          @mousewheel="handleKeyDown"
          class="no-spinners"
        ></v-text-field>
      </td>
      <td>
        <v-text-field
          type="number"
          disabled="disabled"
          class="no-spinners"
          @keydown.up.prevent="handleKeyDown"
          @keydown.down.prevent="handleKeyDown"
          @mousewheel="handleKeyDown"
          v-model="props.item.precio"
        ></v-text-field>
      </td>
      <td>
        <v-text-field
          type="number"
          disabled="disabled"
          class="no-spinners"
          @keydown.up.prevent="handleKeyDown"
          @keydown.down.prevent="handleKeyDown"
          @mousewheel="handleKeyDown"
          v-model="props.item.descuento"
        ></v-text-field>
      </td>
      <td>
        {{
          formatCurrency(props.item.cantidad * props.item.precio - props.item.descuento)
        }}
      </td>
      <td>
        <v-text-field
          type="number"
          v-model="props.item.cantidadDevolucion"
          :disabled="!props.item.selected"  
          @input="validarDevolucion($event,props.item)"
          @keydown.up.prevent="handleKeyDown"
          @keydown.down.prevent="handleKeyDown"
          @mousewheel="handleKeyDown"
          class="no-spinners"
        ></v-text-field>
      </td>
      <td>
        <v-text-field
          type="number"
          disabled="disabled"
          class="no-spinners"
          @keydown.up.prevent="handleKeyDown"
          @keydown.down.prevent="handleKeyDown"
          @mousewheel="handleKeyDown"
          v-model="props.item.descuentoAplicado"
        ></v-text-field>
      </td>
     
      <td>
  {{
    formatCurrency((props.item.cantidadDevolucion || 0) * props.item.precio - (props.item.descuentoAplicado || 0))
  }}
</td>

    </template>
    <template slot="no-data">
      <h3>No hay artículos agregados al detalle.</h3>
    </template>
  </v-data-table>

  <!-- <v-flex class="text-xs-right">
    <strong>Subtotal: </strong>
    {{ (totalParcial = calcularTotal.toFixed(2)) | currency }}
  </v-flex>

  <v-flex class="text-xs-right">
    <strong>Envio: </strong>
    {{ calcularEnvio | currency }}
  </v-flex>

  <v-flex class="text-xs-right">
    <strong>Descuento: </strong>
    {{ calcularDescuento | currency }}
  </v-flex> -->
  <v-flex class="text-xs-right">
    <strong>Subtotal Nota Crédito: </strong>
    {{ formatCurrency(calcularSubtotalNT) }}
  </v-flex>
  <v-flex class="text-xs-right">
    <strong>Descuento Nota Crédito: </strong>
    {{ formatCurrency(calcularDescuentoNT) }}
  </v-flex>
  <v-flex class="text-xs-right">
    <strong>Total Nota Crédito: </strong>
    {{ formatCurrency(calcularTotalGlobal) }}
  </v-flex>

  <!-- <v-flex v-if="esEfectivo" class="text-xs-right">
    <strong>Efectivo: </strong>
    {{ pagar | currency }}
  </v-flex>

  <v-flex v-if="esEfectivo" class="text-xs-right">
    <strong>Cambio: </strong>
    {{
      (cambio =
        parseFloat(pagar).toFixed(2) -
        (parseFloat(totalImpuesto) + parseFloat(totalParcial)).toFixed(2)) | currency
    }}
  </v-flex> -->
</v-flex>


          <v-flex xs12 sm12 md12 lg12 xl12>
            <div
              class="red--text"
              v-for="v in validaMensaje"
              :key="v"
              v-text="v"
            ></div>
          </v-flex>
       
          <v-flex xs12 sm4 md4 lg4 xl4>
            <v-text-field
      v-model="observaciones"
      label="Observaciones"
      outlined
      dense
      rows="6"
      maxlength="500"
      counter
      multi-line
    ></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md12 lg12 xl12>
            <v-btn @click="ocultarNuevo()" color="blue darken-1" flat
              >Cancelar</v-btn
            >
            <v-btn
              v-if="verDet == 0"
              :disabled="ocultarboton"
              @click="guardar()"
              color="success"
              >Guardar</v-btn
            >
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
  </v-layout>
</template>
<script>
import Vue from "vue";
import {
  AutoCompletePlugin,
  AutocompletePlugin,
} from "@syncfusion/ej2-vue-dropdowns";
Vue.use(AutoCompletePlugin);
import axios from "axios";
import jsPDF from "jspdf";
import swal from "sweetalert";
import html2canvas from "html2canvas";
export default {
  data() {
    return {
      descuentoCliente: 0,
      ventas: [],
      selectedItems: [],
      dialog: false,
      ocultarboton: false,
      flag: false,
      checkbox: false,
      cambiarBodega: false,
      esEfectivo: false,
      esContado: false,
      codigoFactura:'',
      totalFactura:'',
      tipoFactura:'',
      sucursalFactura:'',

      headers: [
        { text: "Opciones", value: "opciones", sortable: false },
        { text: "No. Nota Credito", value: "CodigoNc", sortable: false },
        { text: "Tipo Nota Credito", value: "tipoNC", sortable: false },
        { text: "Cliente", value: "cliente", sortable: false },
        { text: "Fecha", value: "fechaCreacion" },
        { text: "Estado", value: "estado" },
        { text: "Total Nota Credito", value: "totalNC", sortable: false },
        { text: "No. Factura", value: "codigoFactura", sortable: false },
        { text: "Sucursal", value: "sucursal", sortable: false },
        { text: "Vendedor", value: "usuario", sortable: false },
        { text: "Tipo Factura", value: "tipo_comprobante", sortable: false }
  
      ],
      // cabeceraDetalles: [
      //   { text: "Selecionar", value: "Selecionar", sortable: false },
      //   { text: "Artículo", value: "articulo", sortable: false },
      //   { text: "Cantidad", value: "cantidad", sortable: false },
      //   { text: "Cantidad Devolucion", value: "cantidadDevolucion", sortable: false },
      //   // { text: "Stock Actual", value: "stock", sortable: false },
      //   { text: "Precio", value: "precio", sortable: false },
      //   { text: "Descuento Factura", value: "precio", sortable: false },
      //   { text: "Descuento Nota Credito", value: "descuentoAplicado", sortable: false },
      //   { text: "Total", value: "total", sortable: false },
      //   // { text: "Descuento", value: "descuento", sortable: false },
      //   // { text: "Subtotal", value: "subtotal", sortable: false },
      // ],
      cabeceraDetalles: [
  { text: "Seleccionar", value: "seleccionar", sortable: false },
  { text: "Artículo", value: "articulo", sortable: false },
  { text: "Cantidad Factura", value: "cantidad", sortable: false },
  { text: "Precio", value: "precio", sortable: false },
  { text: "Descuento Factura", value: "descuentoFactura", sortable: false },
  { text: "Total Factura", value: "totalFactura", sortable: false },
  { text: "Cantidad Devolución", value: "cantidadDevolucion", sortable: false },
  { text: "Descuento Nota Crédito", value: "descuentoNotaCredito", sortable: false },
  { text: "Total Nota Crédito", value: "totalNotaCredito", sortable: false },
],

      detalles: [],
      search: "",
      id: "",
      customer: "",
      userId: "",
      isPreview: true,
      idbodega: "",
      idUsuarioContador:1028,
      nombrecliente: "",
      departamento: "",
      telefono: "",
      clientes: [],
      vendedores: [],
      bodegas: [],
      tipo_envio: "",
      num_factura: 0,      
      noNotaCredito: 0,      
      tipoNC: 0,      
      subtotalNC: 0,      
      descuentoNC: 0,      
      totalNC: 0,      
      tipoPago:"",
      descripcionPago:"",
      tipocomprobante: "",
      tipocomprobante2: "Todas",
      comprobantes: ["Devolucion", "Producto defectuoso","Descuento"],
      comprobantes2: ["Todas","Devolucion", "Producto defectuoso","Descuento"],
      tipoPagos: ["EFECTIVO", "TRANSFERENCIA"],
      envios: ["CARGOTRANS", "MOTORIZADO"],
      impuesto: 0,
      observaciones: "",
      codigo: "",
      verNuevo: 0,
      errorArticulo: null,
      totalParcial: 0,
      totalImpuesto: 0,
      total: 0,
      cambio: 0,
      tasacambio: "",
      totalDolar: 0,
      cabeceraFacturas: [
        { text: "Seleccionar", value: "seleccionar", sortable: false },
        { text: "No. Factura", value: "codigoFactura", sortable: false },
        { text: "Cliente", value: "cliente", sortable: false },
        { text: "Tipo de Factura", value: "tipo_comprobante", sortable: false },
        { text: "Sucursal", value: "sucursal", sortable: false },
        { text: "Vendedor", value: "usuario", sortable: false },
        { text: "Fecha Factura", value: "fecha_hora", sortable: false },
        { text: "Total", value: "total", sortable: false },
      ],
      articulos: [],
      texto: "",
      verArticulos: 0,
      verDet: 0,
      valida: 0,
      validaMensaje: [],
      adModal: 0,
      adAccion: 0,
      adNombre: "",
      adId: "",
      adIdSucursal: "",
      comprobanteModal: 0,
      cliente: "",
      vendedor: "",
      num_documento: "",
      fecha_hora: "",
      num_factura: "",
      observaciones: "",
      direccion: "",
      telefono: "",
      email: "",
      descuento: 0,
      aplicarDescuento: 0,


    };
  },

  computed: {
    calcularTotal: function () {
      var resultado = 0.0;
      if(this.detalles.length > 0){
        for (var i = 0; i < this.detalles.length; i++) {
        resultado =
          resultado +
          (this.detalles[i].precio * this.detalles[i].cantidad);
        }
      }
      
      return resultado;
    },
    calcularDescuentoNT: function(){
          var resultado = 0.0;
      if(this.selectedItems.length > 0){
        for (var i = 0; i < this.selectedItems.length; i++) {
        resultado =
          resultado +
          this.selectedItems[i].descuentoAplicado;
        }
      }
      return parseFloat(resultado);
    },
    calcularTotalGlobal: function(){
      if(parseFloat(this.descuento)>0){
        return this.descuento;
      }
      var resultado = 0.0;
      if(this.selectedItems.length > 0){
        for (var i = 0; i < this.selectedItems.length; i++) {
        resultado =
          resultado +
          (this.selectedItems[i].precio * this.selectedItems[i].cantidadDevolucion - this.selectedItems[i].descuentoAplicado);
        }
      }
      return parseFloat(resultado);
    },

    calcularSubtotalNT: function(){
      if(parseFloat(this.descuento)>0){
        return this.descuento;
      }
      var resultado = 0.0;
      if(this.selectedItems.length > 0){
        for (var i = 0; i < this.selectedItems.length; i++) {
        resultado =
          resultado +
          (this.selectedItems[i].precio * this.selectedItems[i].cantidadDevolucion);
        }
      }
      return parseFloat(resultado);
    },
    calcularEnvio: function () {
      var resultado = 0.0;
      resultado = this.impuesto;
      return resultado;
    },
    calcularDescuento() {
    return this.detalles.reduce((total, detalle) => {
        const descuento = detalle.descuento || 0; // Garantizar un valor por defecto
        return total + descuento; // Sumar el descuento actual al total acumulado
    }, 0); // Iniciar el acumulador en 0
},


    calcularTotalDolar: function () {
      return (
        (parseFloat(this.totalImpuesto) + parseFloat(this.totalParcial)) /
        this.tasaCambio
      );
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.listar();
    this.select();
  },
  methods: {
    toggleSelection(item) {
    // Si el checkbox está marcado, lo agregamos a selectedItems
    if(this.tipocomprobante == ''){
      this.$nextTick(() => {
          item.selected = false; 
        });
      swal(
        "Error",
        "Debe de seleccionar el tipo de nota de credito",
        "warning"
      );
      return;
    }
    if(this.tipocomprobante == 'Descuento'){
      this.$nextTick(() => {
          item.selected = false; 
        });
      swal(
        "Error",
        "Tipo de nota credito descuento no necesita seleccionar los articulos",
        "warning"
      );
      return;
    }
    if (item.selected) {
      // Agregar a selectedItems
      this.selectedItems.push(item);
    } else {
      // Si no está marcado, eliminamos el artículo de selectedItems
      item.descuentoAplicado =0;
      item.cantidadDevolucion =0;
      const index = this.selectedItems.findIndex(i => i.idarticulo === item.idarticulo);
      if (index !== -1) {
        this.selectedItems.splice(index, 1);  // Elimina el artículo
      }
    }
  },
    validarDevolucion: function (event, item) {
  if (event && item) {
    // Compara si la cantidad de devolución es mayor que la cantidad disponible
    if (parseInt(event) > parseInt(item.cantidad)) {
      // Si es mayor, muestra el mensaje de error y pone la cantidadDevolucion a vacío
      swal(
        "Error",
        "No se puede hacer una devolución mayor a la disponible",
        "warning"
      );
      // Restablecer la cantidadDevolucion a un valor vacío o 0 según prefieras
      item.cantidadDevolucion = 0;
    } else {
      // Si no, actualiza la cantidadDevolucion
      item.cantidadDevolucion = parseInt(event);
      
    // const index = this.detalles.findIndex(d => d.idarticulo === item.idarticulo);
    }
    console.log({item})
    const descuentoCliente = parseInt(item.descuento)   / parseInt(item.cantidad);
    item.descuentoAplicado = event * descuentoCliente;
    // Asegura que la lista se actualice correctamente
    const index1 = this.detalles.findIndex(d => d.idarticulo === item.idarticulo);
    const index2 = this.selectedItems.findIndex(d => d.idarticulo === item.idarticulo);
    if (index1 !== -1) {
      // Esto asegura que Vue detecte el cambio en el objeto
      this.$set(this.detalles, index1, { ...item });
    }
    if (index2 !== -1) {
      // Esto asegura que Vue detecte el cambio en el objeto
      this.$set(this.selectedItems, index2, { ...item });
    }
  }
},


    onChange: function (event) {
      console.log(this.selectedValue);
    },
    handleKeyDown(event) {
      event.preventDefault(); // Evitar el comportamiento por defecto de la flecha hacia arriba
    },
    validarCheck() {     
        this.tipo_envio = "";
        this.impuesto = 0;
      
    },
    formatCurrency(amount) {
      return `C$ ${new Intl.NumberFormat("es-NI").format(amount)}`;
    },
    clienteGenerico: function (event) {
      this.nombrecliente = "";
      this.departamento = "";
      this.telefono = "";
      if (event == 13683) {
        this.flag = true;
      } else {
        this.flag = false;
      }
      let me = this;
      me.articulos = [];
      me.articulos.pop();
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get(
          "api/Personas/GetClientePorId/" + event,
          configuracion
        )
        .then(function (response) {
          me.descuentoCliente = response.data.descuento;
          // me.i = response.data;
          if (me.detalles.length > 0) {
                me.detalles.forEach(detalle => {
                    // Recalcular el descuento para cada detalle basado en cantidad y el descuento del cliente
                    detalle.descuento = detalle.cantidad * me.descuentoCliente;
                });
                console.log('Descuentos recalculados:');
                console.log(me.detalles); // Muestra los detalles con los nuevos descuentos
            }
        })
        .catch(function (error) {
          console.log(error);
        });

       
    },

    // validarTipoFactura: function (event) {
    //   if(event==='CONTADO'){
    //     this.esContado = true
    //   }
    //   else{
    //     this.esEfectivo=false;
    //     this.esContado = false;
    //     this.tipoPago ="";
    //   }
    // },
    // validarFormaDePago: function (event) {
    //   if(event==='EFECTIVO'){
    //     this.esEfectivo = true;
    //     this.descripcionPago="";
    //   }
    //   else{
    //     this.esEfectivo = false;
    //     this.pagar=0;
    //   }
    // },

    redirigir() {
      // this.$router.push({ name: "login" });
      this.$store.dispatch("salir");
    },

    customSort(items, index, isDesc) {
      items.sort((a, b) => {
        if (index === "date") {
          if (!isDesc) {
            return compare(a.date, b.date);
          } else {
            return compare(b.date, a.date);
          }
        }
      });
      return items;
    },

    // imprimir() {
    //   //window.print();
    //   this.isPreview = false;
    //   var divToPrint = document.getElementById("ticket");
    //   //console.log(divToPrint);
    //   var newWin = window.open("", "Print-Window");

    //   newWin.document.open();

    //   newWin.document.write(
    //     '<html><body font color="red" face="Times New Roman" size="+1" onload="window.print()">' +
    //       divToPrint.innerHTML +
    //       "</body></html>"
    //   );

    //   newWin.document.close();

    //   setTimeout(function () {
    //     newWin.print();
    //     newWin.close();
    //   }, 1000);
    //   //setTimeout(function(){ newWin.close();},10);
    // },
//     imprimir() {
//   this.isPreview = false;

//   this.$nextTick(() => {
//     const divToPrint = document.getElementById("ticket");

//     if (divToPrint) {
//       const newWin = window.open("", "Print-Window");

//       newWin.document.open();
//       newWin.document.write(
//         `<html><head><style>body { font-family: Arial, sans-serif; }</style></head><body onload="window.print()">` +
//         divToPrint.innerHTML +
//         `</body></html>`
//       );
//       newWin.document.close();

//       setTimeout(() => {
//         newWin.print();
//         newWin.close();
//         this.isPreview = true;
//       }, 1000);
//     } else {
//       console.error("No se pudo encontrar el div con id 'ticket'.");
//     }
//   });
// },

imprimir() {
  this.isPreview = false;

  this.$nextTick(() => {
    const divToPrint = document.getElementById("ticket");

    if (divToPrint) {
      const newWin = window.open("", "Print-Window");

      const printStyles = `
        <style>
          table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 20px;
          }

          th, td {
            border: 1px solid #ddd;
            padding: 8px;
            text-align: left;
            font-weight: bold !important;
          }

          tr {
            page-break-inside: avoid;
          }

          tfoot {
            display: table-footer-group;
          }

          tbody {
            display: table-row-group;
          }

          @media print {
            table {
              page-break-inside: auto !important;
            }

           tfoot {
            display: table-row-group !important;
            page-break-inside: avoid !important;
         }

            tr {
              page-break-inside: avoid;
            }

             tfoot {
              page-break-inside: avoid;
            }
          }
        </style>
      `;

      newWin.document.open();
      newWin.document.write(
        `<html>
          <head>${printStyles}</head>
          <body onload="window.print()">
            ${divToPrint.innerHTML}
          </body>
        </html>`
      );
      newWin.document.close();

      setTimeout(() => {
        newWin.close();
        this.isPreview = true;
      }, 1000);
    } else {
      console.error("No se pudo encontrar el div con id 'ticket'.");
    }
  });
},





    // crearPDF() {
    //   //var quotes = document.getElementById("factura");
    //   var quotes = document.getElementById("ticket-preview");
    //   html2canvas(quotes).then(function (canvas) {
    //     var imgData = canvas.toDataURL("image/png");
    //     var imgWidth = 210;
    //     //var pageHeight = 295;
    //     var pageHeight = 295;
    //     var imgHeight = (canvas.height * imgWidth) / canvas.width;
    //     var heightLeft = imgHeight;
    //     //var doc = new jsPDF("p", "mm", "a4");
    //     var doc = new jsPDF("p", "pt", "letter");
    //     var position = 0;

    //     doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
    //     doc.save("FacturaVenta.pdf");
    //   });
    // },
    crearPDF() {
  var quotes = document.getElementById("ticket-preview");
  html2canvas(quotes).then(function(canvas) {
    var imgData = canvas.toDataURL('image/png');
    var imgWidth = 210; // Ancho de la página en mm (A4)
    var pageHeight = 295; // Altura de la página en mm (A4)
    var imgHeight = canvas.height * imgWidth / canvas.width;
    var heightLeft = imgHeight;

    var doc = new jsPDF('p', 'mm');
    var position = 0;

    // Primera página
    doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    // Manejo de páginas adicionales
    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      doc.addPage();
      doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    // Generar el archivo PDF y descargarlo
    const fileName = `Factura_${new Date().toISOString().split('T')[0]}.pdf`;
    doc.save(fileName);

    // // Abrir WhatsApp con un mensaje preconfigurado
    // const numeroWhatsApp = "5211234567890"; // Número de WhatsApp en formato internacional
    // const mensaje = encodeURIComponent("Hola, aquí está la factura generada. Por favor, adjunta el archivo descargado.");
    // const whatsappURL = `https://wa.me/${numeroWhatsApp}?text=${mensaje}`;
    // window.open(whatsappURL, '_blank'); // Abre WhatsApp en una nueva pestaña
  });
},

    mostrarComprobante(item) {
      this.limpiar();
      console.log("Items: ", item);
      if (item.idcliente == 13683) {
        this.limpiar();
        this.tipo_comprobante = item.tipo_comprobante;
        this.num_factura = item.codigoFactura;
        this.noNotaCredito = item.codigoNC;
        this.tipoNC = item.tipoNc;
        this.subtotalNC = item.subtotalNC;
        this.descuentoNC = item.descuentoNC;
        this.totalNC = item.totalNC;
        this.cliente = item.nombreCliente;
        this.vendedor = item.usuario;
        this.num_documento = item.num_documento;
        this.fecha_hora = item.fechaCreacion;
        this.direccion = item.departamento;
        this.telefono = item._telefono;
        this.email = item.email;
        this.impuesto = item.impuesto;
        this.tasaCambio = item.tasaCambio;
        this.observaciones = item.observaciones;
        this.listarDetallesNC(item.idNotaCredito);
        this.comprobanteModal = 1;
      } else {
        this.limpiar();
        this.tipo_comprobante = item.tipo_comprobante;
        this.num_factura = item.codigoFactura;
        this.noNotaCredito = item.codigoNC;
        this.tipoNC = item.tipoNc;
        this.subtotalNC = item.subtotalNC;
        this.descuentoNC = item.descuentoNC;
        this.totalNC = item.totalNC;
        this.cliente = item.cliente;
        this.vendedor = item.usuario;
        this.num_documento = item.num_documento;
        this.fecha_hora = item.fechaCreacion;
        this.direccion = item.direccion;
        this.telefono = item.telefono;
        this.email = item.email;
        this.impuesto = item.impuesto;
        this.tasaCambio = item.tasaCambio;
        this.observaciones = item.observaciones;
        this.listarDetallesNC(item.idNotaCredito);
        this.comprobanteModal = 1;
      }
    },
    ocultarComprobante() {
      this.comprobanteModal = 0;
      this.isPreview = true; 
      this.limpiar();
    },
    mostrarNuevo() {
      this.verNuevo = 1;
      this.limpiar();
      if (this.$store.state.usuario.idusuario == this.idUsuarioContador) {
      
      let objectInvoice = localStorage.getItem("dataInvoice");

      // Convertir la cadena JSON de vuelta a un objeto
      objectInvoice = JSON.parse(objectInvoice);

      // Ahora, objetoRecuperado contiene el objeto original almacenado en localStorage
      console.log(objectInvoice);
      if(objectInvoice){
        //Inicializar campos
        
        this.userId = parseInt(objectInvoice.idusuario);
        this.idbodega = parseInt(objectInvoice.idsucursal);
        this.customer = objectInvoice.idcliente; 
        this.tasacambio = objectInvoice.tasaCambio; 
        this.tipocomprobante = objectInvoice.tipo_comprobante;
        console.log(this.tasacambio)
      }
    }
    },
    ocultarNuevo() {
      this.verNuevo = 0;
      this.flag = false;
      this.limpiar();
    },
 
    listarArticulo() {
      let me = this;
      me.articulos = [];
      me.articulos.pop();
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get(
          "api/NotaCredito/ListarVentaCliente/" + me.customer + "/" + me.texto,
          configuracion
        )
        .then(function (response) {
          //console.log(response);
          me.articulos = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    mostrarArticulos() {
      if(!this.customer){
        swal(
              "Error al realizar Nota Crédito",
              "Debe de selecionar el cliente para poder agregar una factura",
              "warning"
            );
        return
      }
      this.verArticulos = 1;
      this.listarArticulo()
    },
    ocultarArticulos() {
      this.articulos = [];
      this.articulos.pop();
      this.texto = "";
      this.verArticulos = 0;
    },
    async agregarDetalle(data = []) {
      this.detalles =[]
      this.selectedItems= [];
      this.idventa = data["idventa"];
      this.codigoFactura = data["codigoFactura"];
      this.totalFactura = data["total"];
      this.tipoFactura = data["tipo_comprobante"];
      this.sucursalFactura = data["sucursal"];
     await this.listarDetalles(data["idventa"])
     this.detalles = this.detalles.map(detalle => ({
    ...detalle,  // Mantiene las propiedades actuales
    cantidadDevolucion: 0  // Agrega el campo cantidadDevolucion
  }));   
      this.verArticulos = 0;
},
    encuentra(id) {
      var sw = 0;
      for (var i = 0; i < this.detalles.length; i++) {
        if (this.detalles[i].idarticulo == id) {
          sw = 1;
        }
      }
      return sw;
    },
    eliminarDetalle(arr, item) {
      var i = arr.indexOf(item);
      if (i !== -1) {
        arr.splice(i, 1);
      }
    },

    listar() {
     
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      let url = "";
      url = "api/NotaCredito/ListarNotaCredito/"+me.tipocomprobante2;

      axios
        .get(url, configuracion)
        .then(function (response) {
          me.ventas = response.data;
        })
        .catch(function (error) {
          if (error.response.status == "401") {
            swal(
              "Sesión caducada",
              "Su sesión ha expirado favor volver a iniciar sesión",
              "warning"
            );
            me.redirigir();
          }
        });
    },
    async listarDetalles(id) {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/NotaCredito/ListarDetalles/" + id, configuracion)
        .then(function (response) {
          //console.log(response);
          me.detalles = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async listarDetallesNC(id) {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/NotaCredito/ListarDetallesNC/" + id, configuracion)
        .then(function (response) {
          //console.log(response);
          me.detalles = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    verDetalles(item) {
      this.limpiar();
      // this.idventa = data["idventa"];
      // this.codigoFactura = data["codigoFactura"];
      // this.totalFactura = data["total"];
      // this.tipoFactura = data["tipo_comprobante"];
      // this.sucursalFactura = data["sucursal"];
      this.tipocomprobante = item.tipo_comprobante;
      this.codigoFactura = item.codigoNC;
      this.totalFactura = item.codigoNC;
      this.customer = item.idCliente;
      this.userId = item.idusuario;
      this.impuesto = item.impuesto;
      this.cambio = item.cambio;
      this.pagar = item.pagar;
      this.tasacambio= item.tasaCambio;
      this.tipoPago= item.tipoPago;
      this.descripcionPago= item.descripcionPago;
      this.listarDetallesNC(item.idNotaCredito);
      // this.validarTipoFactura(item.tipo_comprobante);
      // this.validarFormaDePago(item.tipoPago);
      this.verNuevo = 1;
      this.verDet = 1;
    },
    select() {
      let me = this;
      var clientesArray = [];
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Personas/SelectClientes", configuracion)
        .then(function (response) {
          clientesArray = response.data;
          // console.log(clientesArray);
          clientesArray.map(function (x) {
            me.clientes.push({ text: x.nombre, value: x.idpersona });
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    selectUsuario() {
      let me = this;
      var usuariosArray = [];
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Usuarios/Select", configuracion)
        .then(function (response) {
          usuariosArray = response.data;
          usuariosArray.map(function (x) {
            me.vendedores.push({ text: x.nombre, value: x.idusuario });
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectSucursal() {
      let me = this;
      var BodegasArray = [];
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Articulos/Sucursal", configuracion)
        .then(function (response) {
          BodegasArray = response.data;
          console.log("Bodegas", BodegasArray);
          BodegasArray.map(function (x) {
            me.bodegas.push({ text: x.name, value: x.id });
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    limpiar() {
      this.id = "";
      // this.idcliente = "";
      // this.idusuario = "";
      // this.tipo_comprobante = "";
      this.customer="";
      this.userId="";
      this.tipocomprobante="";
      this.impuesto = 0;
      this.codigo = "";
      this.detalles = [];
      this.validaMensaje = [];
      this.total = 0;
      this.pagar = 0;
      this.cambio = 0;
      this.totalImpuesto = 0;
      this.totalParcial = 0;
      this.verDet = 0;
      this.texto = "";
      this.nombrecliente = "";
      this.departamento = "";
      this.telefono = "";
      this.tipo_envio = "";
      this.checkbox = false;
      this.tasacambio = 36.62;
      this.descuento=0;
      this.selectedItems =[];
      this.codigoFactura  = "";
      this.sucursalFactura  = "";
      this.totalFactura  = "";

    },
    guardar() {
      if (this.validar()) {
        return;
      }
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;
      me.ocultarboton = true;
      
          const notaCredito = {
          TipoNotaCredito: this.tipocomprobante,
          IdVenta: this.idventa,
          IdUsuario:  this.$store.state.usuario.idusuario,
          SubTotal: this.calcularSubtotalNT,
          Descuento: this.calcularDescuentoNT,
          Total: this.calcularTotalGlobal,
          Observaciones: this.observaciones,
          detalles: this.selectedItems.map(item => ({
              IdProducto: item.idarticulo,
              Cantidad: item.cantidadDevolucion,
              Precio: item.precio,
              Descuento: item.descuentoAplicado || 0, 
              Total: item.total || (item.cantidad * item.precio) - (item.descuentoAplicado || 0)
          }))
      };

      axios
        .post(
          "api/NotaCredito/Crear",
          notaCredito,
          configuracion
        )

        .then(function (response) {
          console.log(response.data);
          console.log(response.data.id_Venta);
          // me.listarDetalles(response.data.id_Venta);
          // me.mostrarComprobante(me.detalles)
          swal(
            "Nota Crédito realizada",
            `La Nota Crédito se ha realizado correctamente \n No. Factura ${response.data.codigoFactura} `,
            "success"
            //this.listarDetalles(response.data)
          );

          //alert(response);
          me.ocultarboton = false;
          me.ocultarNuevo();
          me.listar();
          me.limpiar();
        })
        .catch(function (error) {
          console.log(error)
          console.log("{{Error}}", error.response.data);
          console.log("{{Message}}", error.response.data.message);
          if (error.response.data.ok) {
            swal(
              "Error al realizar venta",
              error.response.data.message,
              "error"
            );
          } else {
            swal(
              "Error al realizar venta",
              "La venta no se ha realizado correctamente",
              "error"
            );
          }
          //   alert(error);

          me.ocultarboton = false;
        });
    },
    limpiarData: function () {
      this.detalles =[];       
      this.selectedItems =[];   
      this.codigoFactura='';
      this.sucursalFactura='';
      this.totalFactura='';
      this.tipoFactura='';
    },
    validarNC: function (event) {
      if(event=='Descuento'){
        this.aplicarDescuento =1;
        this.selectedItems.forEach(item => {
      item.selected = false; 
      item.cantidadDevolucion=0;
      item.descuentoAplicado=0;
    });
    this.detalles.forEach(item => {
      item.selected = false; 
      item.cantidadDevolucion=0;
      item.descuentoAplicado=0;
    });
      }
    else{
      this.aplicarDescuento =0;
    }

    },
    validar() {
      const notaCredito = {
          TipoNotaCredito: this.tipocomprobante,
          IdVenta: this.idventa,
          IdUsuario:  this.$store.state.usuario.idusuario,
          SubTotal: this.calcularSubtotalNT,
          Descuento: this.calcularDescuentoNT,
          Total: this.calcularTotalGlobal,
          Observaciones: this.observaciones,
          detalles: this.selectedItems.map(item => ({
              IdProducto: item.idarticulo,
              Cantidad: item.cantidadDevolucion,
              Precio: item.precio,
              Descuento: item.descuentoAplicado || 0, 
              Total: item.total || (item.cantidad * item.precio) - (item.descuentoAplicado || 0)
          }))
      };
      this.valida = 0;
      this.validaMensaje = [];
      if (this.detalles.length <= 0) {
        this.validaMensaje.push("La factura Seleccionada no tiene ningun producto disponible.");
        swal(
          "Campos no completados",
          "La factura Seleccionada no tiene ningun producto disponible.",
          "error"
        );
      }

      if (parseFloat(this.totalNC) > parseFloat(this.totalFactura)) {
        this.validaMensaje.push("El monto de la nota de credito no puede ser mayor que la factura");
        swal(
          "Campos no completados",
          "El monto de la nota de credito no puede ser mayor que la factura",
          "error"
        );
      }
      if (this.tipocomprobante === "" || this.tipocomprobante === null || this.tipocomprobante === undefined) 
      {
        this.validaMensaje.push(
          "El tipo Nota de crédito es un campo requerido"
        );
        swal("Campos no completados", "⚠️ Tipo Nota de crédito es un campo requerido", "error");
      }

      if (this.customer === "" || this.customer === null || this.customer === undefined) 
      {
        this.validaMensaje.push(
          "El Cliente es un campo requerido"
        );
        swal("Campos no completados", "⚠️ Cliente es un campo requerido", "error");
      
      }

      if (this.tipocomprobante != 'Descuento' && this.selectedItems.length <= 0) {
        this.validaMensaje.push("Ingrese al menos un artículo al detalle.");
        swal(
          "Campos no completados",
          "Ingrese al menos un artículo al detalle.",
          "error"
        );
      }
      if (
  this.tipocomprobante !== 'Descuento' &&
  (!this.selectedItems || this.selectedItems.length === 0 || this.selectedItems.some(p => p.cantidadDevolucion <= 0 || isNaN(p.cantidadDevolucion)))
) {
  this.validaMensaje.push("⚠️ Hay productos con cantidad inválida.");
  swal("Campos no completados", "⚠️ Hay productos con cantidad inválida o no hay articulos seleccionados.", "error");
}


if (this.tipocomprobante == 'Descuento' && (this.descuento === "" || this.descuento === null || this.descuento === undefined || this.descuento === 0)) {
        this.validaMensaje.push("Debe de ingresar un descuento valido.");
        swal(
          "Campos no completados",
          "Debe de ingresar un descuento valido.",
          "error"
        );
      }
      if (this.tipocomprobante == 'Descuento' && parseFloat(this.descuento) > parseFloat(this.totalFactura)) {
        this.validaMensaje.push("El descuento no debe de ser mayor a la factura.");
        swal(
          "Campos no completados",
          "El descuento no debe de ser mayor a la factura.",
          "error"
        );
    } 
    if (this.tipocomprobante == 'Descuento' && (this.descuento === "" || this.descuento === null || this.descuento === undefined || this.descuento === 0)) {
        this.validaMensaje.push("Debe de seleccionar una factura.");
        swal(
          "Campos no completados",
          "Debe de seleccionar una factura",
          "error"
        );
    } 
    
      if (this.validaMensaje.length) {
        this.valida = 1;
      }
      return this.valida;
    },
    activarDesactivarMostrar(accion, item) {
      console.log("Anular: ", item);
      this.adModal = 1;
      this.adNombre = item.codigoNC;
      this.adId = item.idNotaCredito;
      this.adIdSucursal = item.idsucursal;
      if (accion == 1) {
        this.adAccion = 1;
      } else if (accion == 2) {
        this.adAccion = 2;
      } else {
        this.adModal = 0;
      }
    },
    activarDesactivarCerrar() {
      this.adModal = 0;
    },

    desactivar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put(
          "api/NotaCredito/Anular/" + this.adId,
          {},
          configuracion
        )
        .then(function (response) {
          me.adModal = 0;
          me.adAccion = 0;
          me.adNombre = "";
          me.adId = "";
          me.listar();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>

<style>
@import url(https://cdn.syncfusion.com/ej2/material.css);
#logo {
  margin: 0 auto;
}
#imagen {
  width: 10px;
  margin-top: 0px;
  margin-bottom: 0px;
}

td.producto,
th.producto {
  width: 60px;
  text-align: center;
  max-width: 40px;
  font-size: 8px;
  font-family: "Times New Roman";
  word-break: break-all;
}

td.cantidad,
th.cantidad {
  text-align: center;
  width: 40px;
  max-width: 60px;
  word-break: normal;
  font-size: 8px;
  font-family: "Times New Roman";
}

td.precio,
th.precio {
  width: 60px;
  margin-left: 200px;
  max-width: 40px;
  font-size: 8px;
  text-align: center;
  font-family: "Times New Roman";
  word-break: break-all;
}

#centrado {
  text-align: center;
  align-content: center;
  font-weight: bold;
}

.centrado {
  text-align: center;
  align-content: center;
  font-weight: bold;
}

.texto {
  text-align: center;
  align-content: center;
  margin: auto;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 20px;
}

#ticket {
  width: 255px;
  max-width: 255px;
  font-size: 10px;
  text-align: center;
  font-family: Arial, sans-serif;
  margin-left: 40px;
}

.no-spinners input::-webkit-outer-spin-button,
.no-spinners input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.no-spinners input[type="number"] {
  -moz-appearance: textfield;
}
.okas {
  border-top-style: dotted;
}
img {
  max-width: inherit;
  width: inherit;
}
table {
    width: 100% !important;
    border-collapse: collapse !important;
    margin-bottom: 20px !important;
  }

  th, td {
    border: 1px solid #ddd !important;
    padding: 8px !important;
    text-align: left !important;
  }

  tr {
    page-break-inside: avoid !important; /* Evita que las filas se dividan entre páginas */
  }

  /* Pie de la tabla */
  tfoot {
    display: table-footer-group !important; /* Esto asegura que solo se muestre al final */
  }

  tbody {
    display: table-row-group !important;
  }


@media print {
  /* Evitar que los encabezados se repitan */
  thead {
      display: table-header-group !important;
    }

    /* Solo mostrar el pie de página al final */
    tfoot {
            display: table-row-group !important;
            page-break-inside: avoid !important;
         }

    /* Evitar que las filas se dividan entre páginas */
    tr {
      page-break-inside: avoid !important;
    }


    /* Añadir espacio al final de la última página para evitar corte abrupto */
    @page {
      size: auto !important;
      margin: 10mm !important;
    }

  }


/* preview */
.ticket-preview {
  /* Cambios específicos para la vista previa */
  width: 100%;
  max-width: none;
  font-size: 14px;
  text-align: left;
  margin: 20px auto;
  padding: 20px;
  background-color: #f9f9f9;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
}

.ticket-preview img {
  width: 80px;
  display: block;
  margin: 10px auto;
}

.ticket-preview table {
  width: 100%;
  margin: 20px 0;
  border-collapse: collapse;
}

.ticket-preview th,
.ticket-preview td {
  text-align: center;
  padding: 5px;
  border: 1px solid #ddd;
}

.ticket-preview .centrado {
  text-align: center;
  font-weight: bold;
}


</style>
